var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card__content" },
          [
            _c("k-table", {
              ref: "pacientes",
              attrs: {
                pdfExportable: "",
                path: _vm.path,
                createButton: false,
                editButton: _vm.permiteEditar,
                deleteButton: _vm.permiteEliminar,
                exportable: "",
                columns: [
                  {
                    display: "Foto",
                    value: "url_imagen",
                    image: true
                  },
                  {
                    display: "Nombre",
                    value: "nombre"
                  },
                  {
                    display: "Apellido",
                    value: "apellido"
                  },
                  {
                    display: "Identificación",
                    value: "identificacion"
                  },
                  {
                    display: "Sexo",
                    value: "sexo"
                  },
                  {
                    display: "Fecha de nacimiento",
                    value: "fecha_nacimiento"
                  },
                  {
                    display: "E-mail",
                    value: "email"
                  },
                  {
                    display: "Celular",
                    value: "celular"
                  },
                  {
                    display: "Teléfono",
                    value: "telefono"
                  },
                  {
                    display: "Dirección",
                    value: "direccion"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  },
                  {
                    display: "Modificación",
                    value: "updated_at"
                  },
                  {
                    display: "Modificador",
                    value: "nombre_modificador"
                  }
                ]
              },
              on: { editar: _vm.editar, eliminar: _vm.eliminar }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "paciente",
            scrollable: "",
            width: "80%",
            height: "auto"
          }
        },
        [
          _c("k-paciente", {
            on: { saved: _vm.saved, cancelar: _vm.cancelar },
            model: {
              value: _vm.selectedPaciente,
              callback: function($$v) {
                _vm.selectedPaciente = $$v
              },
              expression: "selectedPaciente"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Consulta de pacientes")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e78a640e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e78a640e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/pacientes/ConsultaPacientes.vue
// module id = 597
// module chunks = 0